<div class="titulo-receber-perspectiva-data-select dropdown">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="perspectiva">
            <span>
                {{perspectiva.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!perspectiva">
            <span>
                Nenhuma Perspectiva
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    *ngIf="canSelectNull"
                    [class.dropdown-item-select]="!idPerspectiva"
                    (click)="select(null)">
                    Nenhuma Referência
                </a>
                <a *ngFor="let temp of perspectivas" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="temp.id == idPerspectiva"
                    (click)="select(temp)">                 
                    {{temp.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>